import React from "react";
import { AppBar, Stack, Toolbar, IconButton, Box, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

const DashboardNavbar = ({ onMenuClick }) => {
  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        borderRadius: 0,
        backgroundColor: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        borderBottom: "1px solid",
        borderColor: "divider",
      }}
    >
      <Toolbar sx={{ minHeight: { xs: 64, md: 72 } }}>
        <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"} spacing={2} sx={{ width: "100%" }}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <IconButton color="inherit" aria-label="open drawer" edge="start" onClick={onMenuClick} sx={{ mr: 2, display: { md: "none" }, color: "text.primary" }}>
              <MenuIcon />
            </IconButton>
            <Box sx={{ display: { xs: "none", md: "block" } }}>
              {/* <img src={Logo} alt='logo' width={100} /> */}
              <Typography variant="h6" color="primary.main" sx={{ fontWeight: 800 }}>
                BT1 Admin
              </Typography>
            </Box>
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default DashboardNavbar;
